import { Outlet, createFileRoute, useMatchRoute } from "@tanstack/react-router";
import { Suspense, lazy } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

// Lazy: pulls in framer-motion + CardContainer; renders null for non-premium
// users, so the entry chunk shouldn't pay for it.
const DownloadAppBanner = lazy(() => import("@/components/DownloadAppBanner"));

export const Route = createFileRoute("/_default")({
  component: RouteComponent,
});

function RouteComponent() {
  const matchRoute = useMatchRoute();
  // The series details page (SHO-757) anchors its own Play bar at the bottom
  // on mobile, permanently — the banner would sit inert behind it.
  const hasOwnBottomBar = !!matchRoute({ to: "/series/$series", fuzzy: true });

  return (
    <div className="flex min-h-dvh flex-col">
      <Header className="fixed top-0 right-0 left-0 z-50" />
      <main className="mx-auto mt-26 w-full flex-1 lg:max-w-5xl">
        <Outlet />
        {/* The wrapper is `w-full` while the banner inside it is
            `mx-auto max-w-md`, so its side gutters are an invisible fixed
            layer over whatever else is anchored at the bottom — they swallowed
            My List's selection bar's clicks. Pointer events are re-enabled on
            the banner itself. */}
        {!hasOwnBottomBar && (
          <div className="pointer-events-none fixed right-1/2 bottom-3 z-50 w-full translate-x-1/2 px-3">
            <Suspense fallback={null}>
              <DownloadAppBanner className="pointer-events-auto mx-auto max-w-md" />
            </Suspense>
          </div>
        )}
      </main>
      <Footer className="border-neutral-60 border-t" />
    </div>
  );
}
